import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
  Grid,
} from "@mui/material";
import React from "react";
import PrimaryButton from "../PrimaryButton";

const StyledFormDialog = styled(Dialog)`
  & .MuiPaper-root {
    border: 12px solid ${(props) => props.theme.palette.background.paper};
    border-radius: ${(props) => props.theme.shape.borderRadius}px;
    background-color: ${(props) => props.theme.palette.background.default};
    background-image: none;
    height: 17rem;
    width: 20rem;
  }
`;

const StyledDialogTitle = styled(DialogTitle)`
  font-weight: bold;
`;

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MessageDialog = ({ dialogConfig, setDialogConfig }) => {
  return (
    <>
      <StyledFormDialog open={dialogConfig.open}>
        <StyledDialogTitle>{dialogConfig.message}</StyledDialogTitle>
        <StyledDialogContent>{dialogConfig.hint}</StyledDialogContent>
        <DialogActions>
          <Grid container justifyContent="space-around">
            <PrimaryButton
              onClick={() => {
                setDialogConfig((prev) => ({
                  ...prev,
                  open: false,
                }));
                dialogConfig.action();
              }}
              sx={{ m: 3 }}
            >
              Update
            </PrimaryButton>
            <PrimaryButton
              onClick={() =>
                setDialogConfig((prev) => ({
                  ...prev,
                  open: false,
                }))
              }
              sx={{ m: 3 }}
            >
              Close
            </PrimaryButton>
          </Grid>
        </DialogActions>
      </StyledFormDialog>
    </>
  );
};
export default MessageDialog;
